// --- smooth scroll --------------
 
// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});
 
lenis.on("scroll", ScrollTrigger.update);
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});
 
gsap.ticker.lagSmoothing(0);
 
// --- smooth scroll --------------


// ---------- MOUSE SCROLL-X ----------
 
function enableLeftClickDragScroll(container) {
    if (!container)
        return;
    let isDragging = !1
      , dragStarted = !1
      , startX = 0
      , scrollStart = 0;
    const dragThreshold = 5;
    container.addEventListener("mousedown", e => {
        e.button === 0 && (isDragging = !0,
        dragStarted = !1,
        startX = e.pageX,
        scrollStart = container.scrollLeft,
        container.classList.add("is-dragging"),
        e.preventDefault())
    }
    ),
    container.addEventListener("mousemove", e => {
        if (!isDragging)
            return;
        const deltaX = e.pageX - startX;
        !dragStarted && Math.abs(deltaX) > dragThreshold && (dragStarted = !0),
        dragStarted && (container.scrollLeft = scrollStart - deltaX)
    }
    ),
    container.addEventListener("mouseup", () => {
        isDragging = !1,
        container.classList.remove("is-dragging")
    }
    ),
    container.addEventListener("mouseleave", () => {
        isDragging = !1,
        container.classList.remove("is-dragging")
    }
    ),
    container.addEventListener("click", e => {
        dragStarted && (e.preventDefault(),
        e.stopPropagation(),
        dragStarted = !1)
    }
    ),
    container.classList.add("is-draggable")
}
function waitForElementAndInit(selector) {
    document.querySelectorAll(selector).forEach(el => {
        el._dragInitialized || (enableLeftClickDragScroll(el),
        el._dragInitialized = !0)
    }
    ),
    new MutationObserver(mutations => {
        for (const mutation of mutations)
            mutation.addedNodes.forEach(node => {
                node instanceof HTMLElement && (node.matches(selector) && !node._dragInitialized && (enableLeftClickDragScroll(node),
                node._dragInitialized = !0),
                node.querySelectorAll?.(selector)?.forEach(el => {
                    el._dragInitialized || (enableLeftClickDragScroll(el),
                    el._dragInitialized = !0)
                }
                ))
            }
            )
    }
    ).observe(document.body, {
        childList: !0,
        subtree: !0
    })
}
document.addEventListener("DOMContentLoaded", () => {
    [".collection .product-grid.slider",".home-tab-products", ".cust-accordion ul"].forEach(selector => {
        waitForElementAndInit(selector)
    }
    )
}
);
 
// ---------- MOUSE SCROLL-X ----------

    gsap.to(".cstm-home-video-ring", {
            rotate: 360,
            duration: 20,
            repeat: -1,
            ease: "none"
        });


        
        if (typeof window.variantChangeUnsubscriber !== 'undefined') {
  window.variantChangeUnsubscriber();
}

window.variantChangeUnsubscriber = subscribe(
  PUB_SUB_EVENTS.variantChange,
  (event) => {
    updateVariantMetafield(event.data.variant.id);
  }
);


document.addEventListener("DOMContentLoaded", function () {

  const toggleAccordion = (event) => {
    const clickedHeader = event.currentTarget;
    const openHeader = document.querySelector(".cust_header_menu_top_accodian h4.active");

    if (openHeader && openHeader !== clickedHeader) {
      openHeader.classList.remove("active");
      openHeader.nextElementSibling.style.maxHeight = null;
    }

    clickedHeader.classList.toggle("active");
    const body = clickedHeader.nextElementSibling;

    if (clickedHeader.classList.contains("active")) {
      body.style.maxHeight = body.scrollHeight + "px";
    } else {
      body.style.maxHeight = null;
    }
  };

  const headers = document.querySelectorAll(".cust_header_menu_top_accodian h4");

  headers.forEach(header => {
    header.addEventListener("click", toggleAccordion);
  });

});


// search
document.addEventListener("DOMContentLoaded", function () {

const searchEl = document.querySelector('details-modal.header__search>details');
const headerMain = document.querySelector('.cstm_main_header');

new MutationObserver(mutations => {
    const isOpen = document.querySelector('details-modal.header__search>details').getAttribute("open");
    if(isOpen){
        headerMain.classList.add("open-search")
    }
    else{
        headerMain.classList.remove("open-search")
    }
}).observe(searchEl, {
    attributes: true
});

})
document.addEventListener("DOMContentLoaded", function () {
let isMobile = innerWidth<950;
const searchElMob = isMobile ? document.querySelectorAll('.header__search>details')[1] : document.querySelector('.cust_header_wrapper_mob_details_right .header__search>details');
const headerMain = document.querySelector('.cstm_main_header');

new MutationObserver(mutations => {
    const isOpen = searchElMob.getAttribute("open");
    if(isOpen){
        isMobile && document.querySelector(".cstm_header_wrapper").setAttribute("style","z-index:1")
        headerMain.classList.add("open-search")
    }
    else{
        isMobile && document.querySelector(".cstm_header_wrapper").setAttribute("style","z-index:3")
        headerMain.classList.remove("open-search")
    }
}).observe(searchElMob, {
    attributes: true
});

})
 
// search

// mobile search for ios close 
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".search-mob-close")[1].addEventListener("click", function(e) {
    e.target.closest(".header__search>details").removeAttribute("open");
  });
});

//


// DEV-03 Card Gallery


// card product gallery

// function snapScrollLeft(el){
//     const mediaWrapper = el.closest(".card__inner")
//     const dotsWrapper = mediaWrapper.querySelector(".card-img-dots")
//     const galleryWrapper = mediaWrapper.querySelector(".card-img-ul")
//     const imgCount = dotsWrapper.querySelectorAll("li").length;
//     const galleryWidth = galleryWrapper.scrollWidth;
//     const scrollAmount = galleryWidth/imgCount;
//     galleryWrapper.scrollBy({ 
//         left: -scrollAmount, 
//         behavior: "smooth" 
//     });
//     const current = dotsWrapper.querySelector("li.active");
//     const previous = current.previousElementSibling;
//     const previoustoPrev = previous.previousElementSibling;
//     const next = el.nextElementSibling;
//     if (previous) {
//     current.classList.remove("active");
//     previous.classList.add("active");
//     }
//      if(next){
//          next.setAttribute("style","opacity:1")
//         //  next.setAttribute("style","opacity:1;pointer-events:all")
//     }
//     if(!previoustoPrev){
//  el.setAttribute("style","opacity:0")
// //  el.setAttribute("style","opacity:0;pointer-events:none")
//     }
// }
// function snapScrollRight(el){
//    const mediaWrapper = el.closest(".card__inner")
//     const dotsWrapper = mediaWrapper.querySelector(".card-img-dots")
//     const galleryWrapper = mediaWrapper.querySelector(".card-img-ul")
//     const imgCount = dotsWrapper.querySelectorAll("li").length;
//     const galleryWidth = galleryWrapper.scrollWidth;
//     const scrollAmount = galleryWidth/imgCount;
//     galleryWrapper.scrollBy({ 
//         left: scrollAmount, 
//         behavior: "smooth" 
//     });
//     const current = dotsWrapper.querySelector("li.active");
//     const prev = el.previousElementSibling;
//     const next = current.nextElementSibling;
//     const nexttoNext = current.nextElementSibling.nextElementSibling;
//     if (next) {
//         current.classList.remove("active");
//         next.classList.add("active");
//     }
//     if(prev){
//         prev.setAttribute("style","opacity:1")
//         // prev.setAttribute("style","opacity:1;pointer-events:all")
//     }
//     if(!nexttoNext){
//         el.setAttribute("style","opacity:0")
//         // el.setAttribute("style","opacity:0;pointer-events:none")
//     }
// }

// function connectDotsChange(){
//    const Cardcontainer = document.querySelectorAll('.card-img-ul');
//             Cardcontainer.forEach((card)=>{
//         const cardWrapper = card.closest(".card");
//         const cardDots = cardWrapper.querySelector(".card-img-dots");
//         const items = card.querySelectorAll('.card-img-ul li');
//         card.addEventListener('scrollend', () => {
//             let liWid = card.clientWidth;
//             let snapLi = Math.round(card.scrollLeft/liWid) + 1;
//             cardDots.querySelector(".card-img-dots li.active").classList.remove("active")
//             cardDots.querySelector(`.card-img-dots li[data-val='${snapLi}']`).classList.add("active")
//             if(snapLi==1){
//                 cardWrapper.querySelector('.ci-left-btn').setAttribute("style","opacity:0")
//             }else{
//                 cardWrapper.querySelector('.ci-left-btn').setAttribute("style","opacity:1")
//             }
//             if(snapLi==items.length){
//                 cardWrapper.querySelector('.ci-right-btn').setAttribute("style","opacity:0")
//             }else{
//                 cardWrapper.querySelector('.ci-right-btn').setAttribute("style","opacity:1")
//             }
//         });
//     });
// }
// function setCardDots(elTag){
//       new MutationObserver(mutations => {
//          connectDotsChange()
//         }).observe(elTag, {
//             childList: !0,
//             subtree: !0,
//         });
// }
// // ------------
// document.addEventListener("DOMContentLoaded",()=>{
//     connectDotsChange()
//     if(location.pathname.includes("/collections/")){
//         const filtData = document.querySelector('aside');
//         setCardDots(filtData)
//     }   
//     if(location.pathname.includes("/products/")){
//         const filtData = document.querySelector('product-recommendations');
//         setCardDots(filtData)
//     }   
// });

// ---------------------


// SMOOTH SCROLL HELPERS
// ---------------------

function snapScrollLeft(el){
    const mediaWrapper = el.closest(".card__inner");
    const dotsWrapper = mediaWrapper.querySelector(".card-img-dots");
    const galleryWrapper = mediaWrapper.querySelector(".card-img-ul");

    const imgCount = dotsWrapper.querySelectorAll("li").length;
    const galleryWidth = galleryWrapper.scrollWidth;
    const scrollAmount = galleryWidth / imgCount;

    galleryWrapper.scrollBy({ 
        left: -scrollAmount, 
        behavior: "smooth" 
    });

    const current = dotsWrapper.querySelector("li.active");
    const previous = current.previousElementSibling;
    const previoustoPrev = previous ? previous.previousElementSibling : null;
    const next = el.nextElementSibling;

    if (previous) {
        current.classList.remove("active");
        previous.classList.add("active");
    }

    if(next){
        next.style.opacity = "1";
    }

    if(!previoustoPrev){
        el.style.opacity = "0";
    }
}


function snapScrollRight(el){
    const mediaWrapper = el.closest(".card__inner");
    const dotsWrapper = mediaWrapper.querySelector(".card-img-dots");
    const galleryWrapper = mediaWrapper.querySelector(".card-img-ul");

    const imgCount = dotsWrapper.querySelectorAll("li").length;
    const galleryWidth = galleryWrapper.scrollWidth;
    const scrollAmount = galleryWidth / imgCount;

    galleryWrapper.scrollBy({ 
        left: scrollAmount, 
        behavior: "smooth" 
    });

    const current = dotsWrapper.querySelector("li.active");
    const prev = el.previousElementSibling;
    const next = current.nextElementSibling;
    const nexttoNext = next ? next.nextElementSibling : null;

    if (next) {
        current.classList.remove("active");
        next.classList.add("active");
    }

    if(prev){
        prev.style.opacity = "1";
    }

    if(!nexttoNext){
        el.style.opacity = "0";
    }
}



// -------------------------------------------
// iOS-SAFE REPLACEMENT FOR THE "scrollend" EVENT
// -------------------------------------------

function onScrollEnd(element, callback, delay = 120) {
    let timeout;
    element.addEventListener("scroll", () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback();
        }, delay);
    });
}



// ---------------------
// DOTS + BUTTON SYNCING
// ---------------------

function connectDotsChange(){
    const Cardcontainer = document.querySelectorAll('.card-img-ul');

    Cardcontainer.forEach(card => {
        const cardWrapper = card.closest(".card");
        const cardDots = cardWrapper.querySelector(".card-img-dots");
        const items = card.querySelectorAll('.card-img-ul li');

        // REPLACED scrollend → onScrollEnd
        onScrollEnd(card, () => {
            const liWid = card.clientWidth;
            const snapLi = Math.round(card.scrollLeft / liWid) + 1;

            // Update dots
            cardDots.querySelector("li.active")?.classList.remove("active");
            cardDots
                .querySelector(`li[data-val='${snapLi}']`)
                ?.classList.add("active");

            // Left button visibility
            const leftBtn = cardWrapper.querySelector('.ci-left-btn');
            leftBtn.style.opacity = snapLi === 1 ? "0" : "1";

            // Right button visibility
            const rightBtn = cardWrapper.querySelector('.ci-right-btn');
            rightBtn.style.opacity = snapLi === items.length ? "0" : "1";
        });
    });
}



// ---------------------
// OBSERVER FOR DYNAMIC CONTENT
// ---------------------

function setCardDots(elTag){
    new MutationObserver(() => {
        connectDotsChange();
    }).observe(elTag, {
        childList: true,
        subtree: true,
    });
}



// ---------------------
// INITIALIZATION
// ---------------------

document.addEventListener("DOMContentLoaded", () => {
    connectDotsChange();

    if (location.pathname.includes("/collections/")) {
        const filtData = document.querySelector('aside');
        if (filtData) setCardDots(filtData);
    }

    if (location.pathname.includes("/products/")) {
        const filtData = document.querySelector('product-recommendations');
        if (filtData) setCardDots(filtData);
    }
});


// card product gallery

// DEV-03 Card Gallery


// active fcets 
document.addEventListener("DOMContentLoaded", function () {
  const facetGroups = document.querySelectorAll(".facets-layout-list");

  facetGroups.forEach(group => {
    const labels = group.querySelectorAll(".mobile-facets__label");

    labels.forEach(label => {
      label.addEventListener("click", function () {
        labels.forEach(l => l.classList.remove("active")); // clear old
        this.classList.add("active"); // new active
      });
    });
  });
});
// active fcets 


//  // call this whenever slide changes; pass newIndex (0-based)
//   function setActiveDot(newIndex) {
//     const dots = document.querySelectorAll('.card-img-dots li');
//     if (!dots || dots.length===0) return;
//     // clamp index
//     const idx = Math.max(0, Math.min(newIndex, dots.length-1));
//     dots.forEach((d,i)=> d.classList.toggle('active', i===idx));
//     // center the active dot visually by shifting the container
//     // this keeps the active dot visually centered inside the clipped area
//     const container = document.querySelector('.card-img-dots');
//     const dot = dots[idx];
//     if (container && dot) {
//       const containerW = container.clientWidth;
//       const dotLeft = dot.offsetLeft + dot.offsetWidth/2;
//       const desired = dotLeft - containerW/2;
//       container.scrollLeft = desired; // scroll instead of transform for smooth centering
//     }
//   }
 
  // Example: connect to your slider event (pseudo)
  // slider.on('slideChange', () => setActiveDot(slider.realIndex));   

//{% comment %} =============== Low Power mode code ============ {% endcomment %}

  document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('video');

    if (!videos.length) return;

    const tryPlay = (video) => {
      if (video.paused) {
        const p = video.play();
        if (p !== undefined) {
          p.catch(() => {});
        }
      }
    };

    // Initial attempt
    videos.forEach((v) => tryPlay(v));

    // iOS-approved user interaction fallback
    const interactionEvents = ['touchstart', 'click', 'pointerdown'];

    const onUserInteraction = () => {
      videos.forEach((v) => tryPlay(v));
      interactionEvents.forEach((evt) => document.removeEventListener(evt, onUserInteraction));
    };

    interactionEvents.forEach((evt) => document.addEventListener(evt, onUserInteraction, { once: true }));

    // Resume if Safari pauses it (common in Low Power Mode)
    videos.forEach((video) => {
      video.addEventListener('pause', () => {
        setTimeout(() => tryPlay(video), 500);
      });
    });
  });

//{% comment %} =============== Low Power mode code ============ {% endcomment %}